import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfig } from '../config/config';
import { Observable } from 'rxjs';
import { MeterRatingSaveDto } from '../models/meterRating.model';

@Injectable({
  providedIn: 'root'
})
export class MeterRatingService {

  private pathApi = this.config.setting['pathApi'] + "meterRating/";

  constructor(private http: HttpClient, private config: AppConfig) { }

  getAll(dataIn: any): Observable<any> {
    return this.http.post(`${this.pathApi}getAll`, dataIn);
  }

  getAllForSelect(): Observable<any> {
    return this.http.get(`${this.pathApi}getAllForSelect`);
  }

  getById(id: number): Observable<any> {
    return this.http.get(`${this.pathApi}getById/${id}`);
  }

  save(dataIn: MeterRatingSaveDto): Observable<any> {
    return this.http.post(`${this.pathApi}save`, dataIn);
  }

  delete(id: number): Observable<any> {
    return this.http.delete(`${this.pathApi}delete/${id}`);
  }
}
